import React from 'react';
import { TEXT_PRIMARY } from '../theme';

function CategoryYAxisTick(props) {
  const {
    x,
    y,
    payload,
    maxChars = 24,
    fill = TEXT_PRIMARY,
    fontSize = 12,
  } = props;

  const raw = String(payload?.value || '');
  const hasHebrew = /[\u0590-\u05FF]/.test(raw);
  const label = raw.length > maxChars ? `${raw.slice(0, maxChars)}…` : raw;

  return (
    <text
      x={x - 8}
      y={y}
      textAnchor="end"
      dominantBaseline="central"
      fill={fill}
      fontSize={fontSize}
      direction={hasHebrew ? 'rtl' : 'ltr'}
      unicodeBidi="plaintext"
    >
      <tspan x={x - 8} dy="0.355em" textAnchor="end">
        {label}
      </tspan>
    </text>
  );
}

export default CategoryYAxisTick;
